// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
// const ARTICLE_ID = '00000000'

class AppComponent extends React.Component<Props> {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const script = document.createElement('script')

    script.src = 'https://dpa-infocom.s3-eu-west-1.amazonaws.com/js/dpa.js'
    script.async = true

    document.body.appendChild(script)
  }

  render() {
    let params = new URL(window.location).searchParams
    let type = params.get('type')

    if (type === 'Sitzverteilung') {
      return (
        <div className='index'>
          <ThemeSwitch />
          <div className='ui vertical segment'>
            <div
              data-app='dpa-electionslive'
              data-embed-type='pym'
              data-competition-id='pw_eu'
              data-language='de'
              data-standalone='seats'
              data-path-css='https://interaktiv.tagesanzeiger.ch/2019/dpa-live-wahlen/'
              data-custom-font='true'
              data-src='https://dpa-electionslive.s3.amazonaws.com/customers/europawahl/aws/dpa-shop-all-languages/html/index.html?language=de'
              data-path='https://dpa-electionslive.s3.amazonaws.com/pw_eu/'
            />
          </div>
        </div>
      )
    }

    if (type === 'Sitzverteilung-Querbalken') {
      return (
        <div className='index'>
          <div className='ui vertical segment'>
            <div
              data-app='dpa-electionslive'
              data-embed-type='pym'
              data-competition-id='pw_eu'
              data-language='de'
              data-standalone='barsList'
              data-value='seats'
              data-path-css='https://interaktiv.tagesanzeiger.ch/2019/dpa-live-wahlen/'
              data-custom-font='true'
              data-src='https://dpa-electionslive.s3.amazonaws.com/customers/europawahl/aws/dpa-shop-all-languages/html/index.html?language=de'
              data-path='https://dpa-electionslive.s3.amazonaws.com/pw_eu/'
            />
          </div>
        </div>
      )
    }

    if (type === 'Prozentuale-Stimmenverteilung-Quer') {
      return (
        <div className='index'>
          <div className='ui vertical segment'>
            <div
              data-app='dpa-electionslive'
              data-embed-type='pym'
              data-competition-id='pw_eu'
              data-language='de'
              data-standalone='barsList'
              data-value='percent'
              data-path-css='https://interaktiv.tagesanzeiger.ch/2019/dpa-live-wahlen/'
              data-custom-font='true'
              data-src='https://dpa-electionslive.s3.amazonaws.com/customers/europawahl/aws/dpa-shop-all-languages/html/index.html?language=de'
              data-path='https://dpa-electionslive.s3.amazonaws.com/pw_eu/'
            />
          </div>
        </div>
      )
    }

    if (type === 'Koalitionsrechner-GB') {
      return (
        <div className='index'>
          <div className='ui vertical segment'>
            <div
              data-app='dpa-electionslive'
              data-embed-type='pym'
              data-competition-id='pw_gb'
              data-language='de'
              data-standalone='coalition'
              data-path-css='https://interaktiv.tagesanzeiger.ch/2019/dpa-live-wahlen/'
              data-custom-font='true'
              data-src='https://dpa-electionslive.s3.amazonaws.com/customers/parlamentswahl-grossbritannien2019/aws/dpa-shop/html/index.html?language=de&customer=tamedia'
              data-path='https://dpa-electionslive.s3.amazonaws.com/pw_gb/'
            />
          </div>
        </div>
      )
    }

    if (type === 'Stimmanteile-Sitzverteilung-GB') {
      return (
        <div className='index'>
          <div className='ui vertical segment'>
            <div
              data-app='dpa-electionslive'
              data-embed-type='pym'
              data-competition-id='pw_gb'
              data-language='de'
              data-standalone='resultsCombi'
              data-standalone-components='bars,seats'
              data-path-css='https://interaktiv.tagesanzeiger.ch/2019/dpa-live-wahlen/'
              data-custom-font='true'
              data-src='https://dpa-electionslive.s3.amazonaws.com/customers/parlamentswahl-grossbritannien2019/aws/dpa-shop/html/index.html?language=de&customer=tamedia'
              data-path='https://dpa-electionslive.s3.amazonaws.com/pw_gb/'
            />
          </div>
        </div>
      )
    }

    if (type === 'test') {
      return (
        <div className='index'>
          <div className='ui vertical segment'>
            <div
              data-app='dpa-electionslive' 
              data-embed-type='pym'  
              data-language='de' 
              data-standalone='headtohead' 
              data-phase='pre' 
              data-result-type='survey' 
              data-view='small'
              data-path-css='https://interaktiv.tagesanzeiger.ch/2019/dpa-live-wahlen/'
              data-custom-font='true'
              data-widget-header='false'
              data-src="https://d3ak46ifsn9mnh.cloudfront.net/customers/praesidentschaftswahl-usa2020/aws/dpa-shop/html/index.html?language=de&customer=tamedia" 
              data-path='https://d3ak46ifsn9mnh.cloudfront.net/pw_us/'
            />
          </div>
        </div>
      )
    }

  }
}

export default hot(module)(AppComponent)
